var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"powered-by"},[_c('img',{staticClass:"logo",attrs:{"src":require("@/assets/images/telex-logo.png")}}),_vm._v(" "),_c('a',{attrs:{"href":"https://telex.hu","target":"_blank"}},[_vm._v("Telex.hu")]),_vm._v(" beágyazás ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }